<template>
  <div>
  <el-container class="container">
    <el-header>
      <topbar></topbar>
    </el-header>

    <el-main>
        <el-row>
          <!-- 桌面端：左侧栏 -->
          <el-col :span="5" class="main-left" v-if="!isMobile">
            <div class="left1">
              <router-view name="left"></router-view>
            </div>
            <div class="left2">
              <chat></chat>
            </div>
          </el-col>

          <el-col :span="isMobile ? 24 : 19" class="main-middle">

            <div id="content">
              <transition :name="transitionName" mode="out-in">
                <navigation>
                <router-view class="child-view"></router-view>
                </navigation>
              </transition>
            </div>
            <!--  :style="{backgroundImage:'url(' + this.ossPath + 'f/豪华官邸_11.jpg)'}" -->
            <div class="middlebottom">
            </div>

          </el-col>
        </el-row>

    </el-main>

    <!-- 移动端：侧滑抽屉（包含左栏内容 + 聊天） -->
    <SlideDrawer>
      <router-view name="left"></router-view>
      <template v-slot:chat>
        <chat></chat>
      </template>
    </SlideDrawer>

    <!-- 移动端：底部状态栏（含罗盘插槽） -->
    <MobileBottomBar>
      <template v-slot:compass>
        <compass v-if="isStreetRoute"></compass>
      </template>
    </MobileBottomBar>
  </el-container>
  <div id="aplayer"></div>
  </div>
</template>
<script>
  import topbar from '../components/header.vue'
  import chat from '../components/chat.vue'
  import compass from '../components/street/compass.vue'
  import MobileBottomBar from '../components/MobileBottomBar.vue'
  import SlideDrawer from '../components/SlideDrawer.vue'
  import {postRequest} from '../utils/api'
  import {getRequest} from '../utils/api'

  import 'aplayer/dist/APlayer.min.css';
  import APlayer from 'aplayer';

export default{

  components: {
    topbar,
    chat,
    compass,
    MobileBottomBar,
    SlideDrawer
  },
  data() {
    return {
      currentUserName: '',
      transitionName: "",
      ap: null,
      musicList: [],
      isMobile: false
    }
  },
  computed: {
    isStreetRoute() {
      return this.$route.path === '/main/street.html';
    }
  },
  mounted: function() {
    // 初始化移动端判断
    this.isMobile = window.innerWidth <= 768;
    this.checkMobile = () => { this.isMobile = window.innerWidth <= 768; };
    window.addEventListener('resize', this.checkMobile);
    // 等 DOM 渲染后再获取音乐列表
    this.$nextTick(() => {
      this.loadMusicList();
    });
    // 仅在首次登录时加载音乐列表，后续 currentUser 事件（如移动）不再重置播放器
    this._musicLoaded = false;
    this.$root.eventHub.$on('currentUser', () => {
      if (!this._musicLoaded) {
        this.loadMusicList();
        this._musicLoaded = true;
      }
    });
  },
  beforeDestroy: function() {
    window.removeEventListener('resize', this.checkMobile);
    this.$root.eventHub.$off('currentUser', this.loadMusicList);
    if (this._aplayerClickOutside) {
      document.removeEventListener('click', this._aplayerClickOutside);
    }
    if (this._aplayerDragCleanup) {
      this._aplayerDragCleanup();
    }
    if (this.ap && this.ap.destroy) {
      try { this.ap.destroy(); } catch (e) {}
    }
    this.removeAPlayer();
  },
  methods: {
    removeAPlayer() {
      var el = document.getElementById('aplayer');
      if (el) {
        el.innerHTML = '';
        el.remove();
      }
    },
    loadMusicList() {
      let _this = this;
      postRequest('/user/music/musicList', {
      }).then(resp=> {
        if (resp.status == 200) {
          var respData = resp.data;
          if (200 == respData.status && null != respData.data) {
            // data 可能是数组，也可能是 { musicList: [...] } 对象
            var rawList = Array.isArray(respData.data) ? respData.data : respData.data.musicList;
            if (rawList && rawList.length) {
              _this.musicList = rawList.map(item => ({
                ...item,
                name: item.name || item.musicName || '',
                artist: item.artist || item.singer || '',
                url: item.url || item.musicUrl || '',
                cover: item.cover || item.coverUrl || '',
                lrc: item.lrc || item.lrcUrl || '',
              }));
              this.$root.musicList = _this.musicList;
            }
          }
        }
        // 无论成功失败，都初始化 APlayer（有歌单用歌单，没有就空列表但 UI 存在）
        _this.initAPlayer(_this.musicList);
      }, resp=> {
        _this.musicList = [];
        _this.initAPlayer(_this.musicList);
      });
    },
    initAPlayer(audio) {
      try {
        if (this._aplayerClickOutside) {
          document.removeEventListener('click', this._aplayerClickOutside);
        }
        if (this.ap && this.ap.destroy) { this.ap.destroy(); this.ap = null; }
        var apContainer = document.getElementById('aplayer');
        if (!apContainer) {
          apContainer = document.createElement('div');
          apContainer.id = 'aplayer';
          document.body.appendChild(apContainer);
        }
        // 如果没有 audio 数据，用一个空数组的占位 entry
        var safeAudio = (audio && audio.length) ? audio : [{
          name: '暂无音乐',
          artist: '请先登录后查看歌单',
          url: '',
          cover: ''
        }];
        this.ap = new APlayer({
          container: apContainer,
          fixed: true,
          mini: true,
          autoplay: false,
          lrcType: 3,
          listFolded: false,
          audio: safeAudio
        });
        // 自定义三横杠按钮：自行管理歌单列表的显示/隐藏
        // 用 preventDefault 阻止 APlayer 原生行为（原生在 fixed+mini 下与自定义定位不兼容）
        // CSS 中 max-height: 250px !important 确保歌单高度不被 APlayer 覆盖
        var self = this;
        self._aplayerListVisible = false;
        var menuBtn = apContainer.querySelector('.aplayer-icon-menu');
        if (menuBtn) {
          menuBtn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            var list = apContainer.querySelector('.aplayer-list');
            if (!list) return;
            self._aplayerListVisible = !self._aplayerListVisible;
            if (self._aplayerListVisible) {
              list.style.display = 'block';
            } else {
              list.style.display = 'none';
            }
          });
        }
        // 点击播放器外部区域时收起播放器和歌单
        self._aplayerClickOutside = function(e) {
          var aplayer = document.getElementById('aplayer');
          if (!aplayer) return;
          if (!aplayer.contains(e.target)) {
            // 收起歌单列表
            var list = aplayer.querySelector('.aplayer-list');
            if (list) list.style.display = 'none';
            self._aplayerListVisible = false;
            // 收起播放器主体（恢复 mini 模式）
            var body = aplayer.querySelector('.aplayer-body');
            if (body && !aplayer.classList.contains('aplayer-narrow')) {
              aplayer.classList.add('aplayer-narrow');
            }
          }
        };
        document.addEventListener('click', self._aplayerClickOutside);
        // 按住拖动换位 + 位置记忆（收起态小方块）
        self.enableAplayerDrag(apContainer);
      } catch (e) {
        console.warn('APlayer init skipped:', e && e.message);
      }
    },
    // 音乐盒拖动：收起态按住小方块拖到任意位置，松手即记忆（按桌面/移动分开存），
    // 下次进入页面自动恢复。位置写入 CSS 变量（--ap-*=桌面 / --ap-m-*=移动），样式层 !important 消费。
    enableAplayerDrag(apContainer) {
      var self = this;
      var body = apContainer.querySelector('.aplayer-body');
      if (!body) return;
      var isMobileMode = window.innerWidth <= 768;
      var posKey = isMobileMode ? 'aplayerPosMobile' : 'aplayerPosDesktop';
      var varPrefix = isMobileMode ? '--ap-m' : '--ap';
      // 恢复上次拖动的位置（与 CSS 默认值解耦）
      try {
        var saved = JSON.parse(localStorage.getItem(posKey) || 'null');
        if (saved && isFinite(saved.right) && isFinite(saved.bottom)) {
          apContainer.style.setProperty(varPrefix + '-right', saved.right + 'px');
          apContainer.style.setProperty(varPrefix + '-bottom', saved.bottom + 'px');
        }
      } catch (e) {}
      var dragging = false, moved = false;
      var startX = 0, startY = 0, baseRight = 0, baseBottom = 0;
      var suppressClick = function (e) {
        e.stopPropagation();
        e.preventDefault();
        document.removeEventListener('click', suppressClick, true);
      };
      var applyPos = function (right, bottom) {
        apContainer.style.setProperty(varPrefix + '-right', right + 'px');
        apContainer.style.setProperty(varPrefix + '-bottom', bottom + 'px');
      };
      var onMove = function (e) {
        if (!dragging) return;
        var point = e.touches ? e.touches[0] : e;
        if (!point) return;
        var dx = point.clientX - startX, dy = point.clientY - startY;
        if (!moved && Math.abs(dx) + Math.abs(dy) <= 6) return; // 6px 内视为点击
        moved = true;
        if (e.cancelable) e.preventDefault(); // 拖动期间阻止页面滚动/选中
        var right = Math.min(Math.max(baseRight - dx, 0), window.innerWidth - body.offsetWidth);
        var bottom = Math.min(Math.max(baseBottom - dy, 0), window.innerHeight - body.offsetHeight);
        applyPos(right, bottom);
      };
      var onUp = function () {
        if (!dragging) return;
        dragging = false;
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onUp);
        document.removeEventListener('touchmove', onMove);
        document.removeEventListener('touchend', onUp);
        document.removeEventListener('touchcancel', onUp);
        if (!moved) return;
        try {
          localStorage.setItem(posKey, JSON.stringify({
            right: parseFloat(apContainer.style.getPropertyValue(varPrefix + '-right')),
            bottom: parseFloat(apContainer.style.getPropertyValue(varPrefix + '-bottom'))
          }));
        } catch (e) {}
        // 拖动落点产生的 click 会误触播放/展开，捕获阶段拦掉这一次
        document.addEventListener('click', suppressClick, true);
        setTimeout(function () {
          document.removeEventListener('click', suppressClick, true);
        }, 300);
      };
      var onDown = function (e) {
        // 仅收起（mini）态可拖：展开态有进度条/音量等控件，拖动会误伤
        if (!apContainer.classList.contains('aplayer-narrow')) return;
        if (e.type === 'mousedown' && e.button !== 0) return;
        var point = e.touches ? e.touches[0] : e;
        if (!point) return;
        var cs = window.getComputedStyle(body);
        dragging = true;
        moved = false;
        startX = point.clientX;
        startY = point.clientY;
        baseRight = parseFloat(cs.right);
        baseBottom = parseFloat(cs.bottom);
        if (isNaN(baseRight) || isNaN(baseBottom)) { dragging = false; return; }
        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', onUp);
        document.addEventListener('touchmove', onMove, { passive: false });
        document.addEventListener('touchend', onUp);
        document.addEventListener('touchcancel', onUp);
        if (e.type === 'mousedown') e.preventDefault();
      };
      body.addEventListener('mousedown', onDown);
      body.addEventListener('touchstart', onDown);
      self._aplayerDragCleanup = function () {
        body.removeEventListener('mousedown', onDown);
        body.removeEventListener('touchstart', onDown);
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onUp);
        document.removeEventListener('touchmove', onMove);
        document.removeEventListener('touchend', onUp);
        document.removeEventListener('touchcancel', onUp);
        document.removeEventListener('click', suppressClick, true);
      };
    },
    handleCommand(command){
        var _this = this;
        if (command == 'logout') {
          this.$confirm('注销登录吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            postRequest("/auth/login/logout")
            _this.currentUserName = '游客';
            _this.$router.replace({path: '/'});
          }, function () {
            //取消
          })
        }
    },
  }
}

</script>
<style>
.child-view {
    position: absolute;
    width:100%;
    transition: all .5s ;
}
.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 0.5s;
  position: absolute;
}
.slide-right-enter {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
.slide-right-leave-to {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}
.slide-left-enter {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}
.slide-left-leave-to {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}

.el-container {
  height: 100vh;
  height: 100dvh;
  position: relative;
  overflow: hidden;
}

.el-header {
  height: 60px !important;
  padding: 0 !important;
}

.el-main {
  background: #fff;
  height: calc(100vh - 60px) !important;
  height: calc(100dvh - 60px) !important;
  padding: 0 !important;
  overflow: hidden;
}

.container {
  width: 100%;
  min-width: 100%;
}

.left1 {
  flex: 0 1 auto;
  max-height: 40%;
  overflow-y: auto;
  padding: 0 6px 0 6px;
}

.left2 {
  flex: 1 1 60%;
  min-height: 60%;
  overflow-y: auto;
  padding: 0 6px 0 6px;
}

#content {
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
  padding: 4px;
}

.main-middle {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.middlebottom {
  position: absolute;
  right: 5px;
  bottom: 5px;
  width: 100px;
  height: 30px;
}

.main-left {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: #2d2340;
}

.row-bg {
  padding: 0 !important;
}

/* 首页主布局专用：仅作用于顶层布局行，避免 height:100% 污染弹窗等任意 el-row */
.container > .el-main > .el-row {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
}

/* 同上方主布局配套：仅首页布局行禁用clearfix（flex不需要），弹窗内el-row恢复原生float+clearfix */
.container > .el-main > .el-row::after,
.container > .el-main > .el-row::before {
  display: none;
}

/* ========== 移动端响应式 ========== */
@media (max-width: 768px) {
  .el-header {
    height: var(--mobile-header-h) !important;
  }
  .el-main {
    height: calc(100dvh - var(--mobile-header-h) - var(--mobile-footer-h)) !important;
  }
  .el-row {
    display: block;
  }
  .main-left, .main-middle {
    width: 100%;
    height: auto;
  }
  .main-middle {
    height: 100%;
  }
  #content {
    padding: 0;
    overflow-y: auto;
  }
  .middlebottom {
    display: none;
  }
}

/* ========== APlayer PC端：右下角快捷条上方，支持按住拖动、位置记忆 ==========
   位置由 CSS 变量控制：--ap-right/--ap-bottom=桌面端，--ap-m-right/--ap-m-bottom=移动端；
   拖动结束时 JS 把新位置写入变量并按设备存 localStorage，刷新/重登后由 JS 恢复 */
#aplayer.aplayer.aplayer-fixed {
  z-index: 300 !important;
}

/* 翻转箭头方向：播放器在右下角，展开← 收起→ 与左下角默认相反 */
.aplayer.aplayer-fixed .aplayer-miniswitcher {
  transform: scaleX(-1) !important;
}

/* 收起状态：小方块在右下角（默认悬在街道快捷条上方） */
.aplayer.aplayer-fixed.aplayer-narrow .aplayer-body {
  position: fixed !important;
  bottom: var(--ap-bottom, 20px) !important;
  right: var(--ap-right, 20px) !important;
  left: auto !important;
}

/* 展开状态：在右下角，向左展开 */
.aplayer.aplayer-fixed:not(.aplayer-narrow) .aplayer-body {
  position: fixed !important;
  bottom: var(--ap-bottom, 20px) !important;
  right: var(--ap-right, 20px) !important;
  left: auto !important;
  width: 360px !important;
}

/* 歌单列表：固定在播放器上方，同宽不超播放器，重置默认margin，z-index高于body防止遮挡 */
.aplayer.aplayer-fixed .aplayer-list {
  position: fixed !important;
  bottom: calc(var(--ap-bottom, 20px) + 66px) !important;
  left: auto !important;
  right: var(--ap-right, 20px) !important;
  width: 360px !important;
  max-height: 350px !important;
  overflow-y: auto !important;
  margin-bottom: 0 !important;
  z-index: 100 !important;
}
/* 歌单内部ol：扩大max-height匹配外层，确保内容完整展示 */
.aplayer.aplayer-fixed .aplayer-list ol {
  max-height: 340px !important;
}

/* APlayer 移动端适配 - 经验条右上方，保持默认方形+展开按钮 */
@media (max-width: 768px) {
  /* 关键：#aplayer 容器本身 z-index 要高于底栏，否则子元素 z-index 再高也没用 */
  #aplayer.aplayer.aplayer-fixed {
    z-index: 300 !important;
  }
  /* 收起状态（narrow）：方形 66x66 靠右，紧贴经验条上方（街道页快捷条在其上方） */
  .aplayer.aplayer-fixed.aplayer-narrow .aplayer-body {
    position: fixed !important;
    bottom: var(--ap-m-bottom, 70px) !important;
    right: var(--ap-m-right, 4px) !important;
    left: auto !important;
    width: 66px !important;
    z-index: 300 !important;
    background: #fff !important;
  }
  /* 展开状态（非 narrow）：铺满屏幕宽度，紧贴经验条上方 */
  .aplayer.aplayer-fixed:not(.aplayer-narrow) .aplayer-body {
    position: fixed !important;
    bottom: var(--ap-m-bottom, 70px) !important;
    left: 0 !important;
    right: 0 !important;
    width: 100vw !important;
    max-width: 100vw !important;
    overflow: hidden !important;
    z-index: 300 !important;
    background: #fff !important;
    box-shadow: 0 -2px 8px rgba(0,0,0,0.2) !important;
    padding-right: 18px !important;
    box-sizing: border-box !important;
  }
  /* 展开 info 占满剩余空间 */
  .aplayer.aplayer-fixed:not(.aplayer-narrow) .aplayer-info {
    max-width: calc(100vw - 84px) !important;
  }
  /* 展开 info 区域可见 */
  .aplayer.aplayer-fixed:not(.aplayer-narrow) .aplayer-info {
    display: block !important;
    transform: scaleX(1) !important;
  }
  /* miniswitcher 始终可点击 */
  .aplayer.aplayer-fixed .aplayer-miniswitcher {
    z-index: 310 !important;
    pointer-events: auto !important;
  }
  /* pic 可点击 */
  .aplayer.aplayer-fixed .aplayer-pic {
    pointer-events: auto !important;
  }
  /* 歌单列表：白色不透明背景，紧贴播放器上方，z-index 高于 aplayer-body */
  .aplayer.aplayer-fixed .aplayer-list {
    position: fixed !important;
    bottom: calc(var(--ap-m-bottom, 70px) + 66px) !important;
    left: 0 !important;
    right: 0 !important;
    width: 100vw !important;
    max-height: 40vh !important;
    z-index: 310 !important;
    background: #fff !important;
    box-shadow: 0 -2px 8px rgba(0,0,0,0.2) !important;
    border: none !important;
    border-radius: 0 !important;
    margin: 0 !important;
    margin-bottom: 0 !important;
  }
}
</style>